import axios from "axios";

function params(obj) {
  //url地址挂参数
  let result = "";
  let item;
  for (item in obj) {
    result += `&${item}=${obj[item]}`;
  }
  if (result) {
    result = "?" + result.slice(1);
  }
  return result;
}

const list = [
  { id: 401, link: "/pqm/quality" },
  { id: 104, link: "/pmdm/changes" },
];

const getUrlPre = (obj) => {
  const n = obj.classId.toString().substring(0, 3);
  const str = list.find((i) => i.id == n)?.link || "";
  return str;
};

export const imdApproveWorkflowAPI = (obj) =>
  axios.post("/ppm/project/imdApproveWorkflow", obj);

export const imdRejectWorkflowAPI = (obj) =>
  axios.post("/ppm/project/imdRejectWorkflow", obj);

// export const rejectChangeAPI = (obj) => {
//   const str = getUrlPre(obj.objectId);
//   axios.post(`${str}/rejectChange`, obj);
// };

export const approveChangeAPI = (obj) => {
  const list = [
    { id: 301, url: "/ppm/project/imdApproveWorkflow" },
    { id: 401, url: "/pqm/quality/approveWorkflow" },
    { id: 104, url: "/pmdm/changes/approveChange" },
  ];
  const id = obj.objectId.classId.toString().substring(0, 3);
  const str = list.find((i) => i.id == id).url;

  return axios.post(`${str}`, obj);
};

export const rejectChangeAPI = (obj) => {
  const list = [
    { id: 301, url: "/ppm/project/imdRejectWorkflow" },
    { id: 401, url: "/pqm/quality/rejectWorkflow" },
    { id: 104, url: "/pmdm/changes/rejectChange" },
  ];
  const id = obj.objectId.classId.toString().substring(0, 3);
  const str = list.find((i) => i.id == id).url;

  return axios.post(`${str}`, obj);
};

export const loadMyWorkFlowsAPI = (id) =>
  axios.get("/pmdm/changes/loadMyWorkFlows?tableType=" + id);

export const loadTableAPI = (obj) =>
  axios.get(`${getUrlPre(obj)}/loadTable${params(obj)}`);

export const loadWorkflowAPI = (obj) =>
  axios.get(`${getUrlPre(obj)}/loadWorkflowTable${params(obj)}`);

export const getStatusAPI = (obj) => {
  const list = [
    { id: 301, url: "/ppm/project/imdApproveWorkflow" },
    { id: 104, url: "/pmdm/admin/workflow/getStatusWithoutHoldCancel" },
    { id: 401, url: "/pqm/quality/getStatusPathNoHoldCancel" },
  ];
  const id = obj.classId.toString().substring(0, 3);
  const str = list.find((i) => i.id == id).url;
  return axios.get(`${str + params(obj)}`);
};
